













import Vue from 'vue'
import { mapGetters, mapActions } from 'vuex'
import Header from '@/components/Header/Header.vue'
import HeaderMobile from '@/components/Header/HeaderMobile.vue'

export default Vue.extend({
  components: {
    Header,
    HeaderMobile
  },
  computed: {
    ...mapGetters(['isModalOpen'])
  },
  methods: {
    ...mapActions('results', ['updateChecksCounter'])
  },
  mounted () {
    this.updateChecksCounter()
  }
})
